import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../swof/api";import LoginPage, { AuthCard, SubmitButton, ErrorLine, inputStyle } from "./LoginPage";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard eyebrow="Beheer" title="Wachtwoord vergeten">
      {sent ? (
        <p data-testid="forgot-sent" style={{ fontFamily: "var(--serif)", fontSize: 17, lineHeight: 1.6, opacity: 0.85 }}>
          Als dit e-mailadres bekend is, is er een resetlink verstuurd.
        </p>
      ) : (
        <form onSubmit={onSubmit}>
          <label style={{ display: "block" }}>
            <span className="eyebrow" style={{ display: "block", marginBottom: 8, fontSize: 10 }}>E-mail</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email" style={inputStyle} />
          </label>
          <ErrorLine error={error} />
          <SubmitButton busy={busy} testId="forgot-submit">Stuur resetlink</SubmitButton>
        </form>
      )}
      <div style={{ marginTop: 22 }}>
        <Link to="/login" style={{
          fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.18em",
          textTransform: "uppercase", color: "var(--gold)", opacity: 0.8,
        }}>← Terug naar inloggen</Link>
      </div>
    </AuthCard>
  );
}

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard eyebrow="Beheer" title="Nieuw wachtwoord">
      <form onSubmit={onSubmit}>
        <label style={{ display: "block" }}>
          <span className="eyebrow" style={{ display: "block", marginBottom: 8, fontSize: 10 }}>Nieuw wachtwoord</span>
          <input type="password" required minLength={8} value={password}
            onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" style={inputStyle} />
        </label>
        <ErrorLine error={error} />
        <SubmitButton busy={busy} testId="reset-submit">Wachtwoord opslaan</SubmitButton>
      </form>
    </AuthCard>
  );
}

export function UitnodigingPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [wie, setWie] = useState(null);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  React.useEffect(() => {
    api.get(`/auth/uitnodiging?token=${encodeURIComponent(token)}`)
      .then(({ data }) => setWie(data))
      .catch((err) => setError(formatApiErrorDetail(err.response?.data?.detail) || err.message));
  }, [token]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard eyebrow="Songwriters Wall of Fame" title="Welkom">
      {wie ? (
        <>
          <p data-testid="uitnodiging-wie" style={{
            fontFamily: "var(--serif)", fontSize: 17, lineHeight: 1.6, opacity: 0.85,
            margin: "0 0 26px",
          }}>
            Hallo {wie.naam || "daar"}. Kies een wachtwoord voor <strong>{wie.email}</strong>;
            daarna kunt u meteen inloggen op het beheer.
          </p>
          <form onSubmit={onSubmit}>
            <label style={{ display: "block" }}>
              <span className="eyebrow" style={{ display: "block", marginBottom: 8, fontSize: 10 }}>
                Wachtwoord (minstens 8 tekens)
              </span>
              <input type="password" required minLength={8} value={password}
                onChange={(e) => setPassword(e.target.value)} data-testid="uitnodiging-wachtwoord"
                style={inputStyle} autoComplete="new-password" />
            </label>
            <ErrorLine error={error} />
            <SubmitButton busy={busy} testId="uitnodiging-submit">Wachtwoord opslaan</SubmitButton>
          </form>
        </>
      ) : (
        <>
          <ErrorLine error={error} />
          {!error && <p data-testid="uitnodiging-laden" style={{ opacity: 0.6 }}>Even kijken…</p>}
          {error && (
            <div style={{ marginTop: 22 }}>
              <Link to="/wachtwoord-vergeten" style={{
                fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.18em",
                textTransform: "uppercase", color: "var(--gold)",
              }}>Vraag een nieuwe link aan</Link>
            </div>
          )}
        </>
      )}
    </AuthCard>
  );
}

export default LoginPage;
